// eslint-disable-next-line n/no-deprecated-api
import { parse } from 'url'

export function getContextEndpoint (endpoint: string): string {
  const url = parse(`http://127.0.01:${process.env.VSF_NUXT_APP_PORT || 3000}/${endpoint}`.replace(/([^:]\/)\/+/g, '$1'))
  return !process.browser ? url.href.replace(/([^:]\/)\/+/g, '$1') : endpoint
}
